import {
  faAngleRight,
  faSpinnerThird,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { type FC, type PropsWithChildren } from 'react'

import { cn } from 'utils/cn'

type Props = {
  count?: number
  isAccordionDisabled?: boolean
  isAccordionOpen: boolean
  isLoading?: boolean
  isSmall?: boolean
  isDimmed?: boolean
  onClick: VoidFunction
}

export const AccordionButton: FC<PropsWithChildren<Props>> = ({
  children,
  count,
  isAccordionDisabled = false,
  isAccordionOpen,
  isLoading = false,
  isSmall,
  isDimmed = false,
  onClick,
}) => (
  <button
    className={cn(
      'flex items-center w-full gap-x-1 group/accordion print:py-0',
      {
        'cursor-default': isAccordionDisabled,
      },
    )}
    onClick={() => !isAccordionDisabled && onClick()}
    type="button"
  >
    <span className={cn('font-medium', {
      'ml-2 text-sm': isSmall,
      'text-subdued': isDimmed,
      'text-default': !isDimmed,
    })}
    >
      {isLoading && (
        <FontAwesomeIcon icon={faSpinnerThird} className="mr-2 animate-spin" />
      )}
      {children}
      {count && (
        <span
          className={cn('ml-1 text-sm', {
            'text-subdued': isDimmed,
            'text-default': !isDimmed,
          })}
        >
          {count}
        </span>
      )}
    </span>
    <span className={cn('mt-0.5', {
      'text-subdued': isDimmed,
      'text-default': !isDimmed,
    })}
    >
      {!isAccordionDisabled && (
        <FontAwesomeIcon
          icon={faAngleRight}
          className={cn('transition print:hidden', {
            'transform rotate-90': isAccordionOpen,
            'text-sm': isSmall,
          })}
        />
      )}
    </span>
  </button>
)
